export interface Point {
  x: number
  y: number
}

export interface DrawerRect {
  left: number
  top: number
  bottom: number
  width: number
}

export function pointerAimsAtDrawer(cur: Point, prev: Point, rect: DrawerRect): boolean {
  if (!rect.width || cur.x >= rect.left || prev.x >= rect.left || (cur.x === prev.x && cur.y === prev.y)) {
    return false
  }
  const slopeTo = (from: Point, cornerY: number) => (cornerY - from.y) / (rect.left - from.x)
  return slopeTo(cur, rect.top) < slopeTo(prev, rect.top) && slopeTo(cur, rect.bottom) > slopeTo(prev, rect.bottom)
}
